import { Button, Popconfirm, Tooltip } from "antd";
import { TooltipPlacement } from "antd/lib/tooltip";
import React from "react";
import { LogOut } from "react-feather";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import i18n from "../../services/i18n";
// Komponent tashqarisida turgani uchun hook emas, i18n.t ishlatiladi.
// Til almashtirilganda sahifa qayta yuklanadi, shuning uchun bu yetarli.
const content2 = (
  <div>
    <p>{i18n.t("logout")}</p>
  </div>
);
export default function LogoutButton({
  button = (
    <Tooltip placement="bottom" title={content2}>
      <Button
        size="large"
        // data-title="Выйти"
        className="buttonHeader_r headermargin_r"
        icon={<LogOut />}
      >
      </Button>
    </Tooltip>
  ),
  placement = "left",
}: {
  placement?: TooltipPlacement;
  button?: JSX.Element;
}) {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <Popconfirm
      onConfirm={() => history.push("/logout")}
      okText={t("yes")}
      placement={placement}
      cancelText={t("no")}
      title={t("sureToLogout")}
    >
      {button}
    </Popconfirm>
  );
}
